import React from 'react';
import { Gift, Users, Check } from 'lucide-react';

function ReferFriend() {
  return (
    <div style={{ 
      backgroundColor: '#0a0e1a',
      minHeight: '100vh',
      padding: '60px'
    }}>
      <div style={{ maxWidth: '900px', margin: '0 auto' }}>
        {/* Header */}
        <div style={{ textAlign: 'center', marginBottom: '50px' }}>
          <div style={{
            width: '70px',
            height: '70px',
            borderRadius: '14px',
            background: 'linear-gradient(135deg, rgba(245, 158, 11, 0.2) 0%, rgba(239, 68, 68, 0.2) 100%)',
            border: '1px solid rgba(245, 158, 11, 0.3)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            margin: '0 auto 25px'
          }}>
            <Gift size={32} color="#f59e0b" />
          </div>
          <h1 style={{ 
            fontSize: '48px',
            fontWeight: '800',
            margin: '0 0 20px 0',
            color: '#ffffff',
            letterSpacing: '-0.5px'
          }}>
            Refer Friends, Get Rewarded
          </h1>
          <p style={{ 
            fontSize: '18px',
            color: '#64748b',
            margin: 0,
            maxWidth: '600px',
            marginLeft: 'auto',
            marginRight: 'auto',
            lineHeight: '1.7'
          }}>
            Share Upperline Bet with your friends and earn free subscription time for every successful referral
          </p>
        </div>

        {/* How It Works */}
        <div style={{
          backgroundColor: '#1a1f2e',
          border: '1px solid #2d3748',
          borderRadius: '12px',
          padding: '40px',
          marginBottom: '40px'
        }}>
          <h2 style={{ 
            margin: '0 0 30px 0',
            fontSize: '28px',
            fontWeight: '700',
            color: '#ffffff',
            textAlign: 'center'
          }}>
            How It Works
          </h2>
          
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '30px' }}>
            {/* Step 1 */}
            <div style={{ textAlign: 'center' }}>
              <div style={{
                width: '50px',
                height: '50px',
                borderRadius: '10px',
                backgroundColor: '#0f1419',
                border: '2px solid #00d9ff',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                margin: '0 auto 20px',
                fontSize: '24px',
                fontWeight: '800',
                color: '#00d9ff',
                fontFamily: 'monospace'
              }}>
                1
              </div>
              <h3 style={{ 
                margin: '0 0 12px 0',
                fontSize: '18px',
                fontWeight: '700',
                color: '#ffffff'
              }}>
                Share Your Link
              </h3>
              <p style={{ 
                fontSize: '14px',
                color: '#a0aec0',
                margin: 0,
                lineHeight: '1.6'
              }}>
                Get your unique referral link and share it with friends
              </p>
            </div>

            {/* Step 2 */}
            <div style={{ textAlign: 'center' }}>
              <div style={{
                width: '50px',
                height: '50px',
                borderRadius: '10px',
                backgroundColor: '#0f1419',
                border: '2px solid #10b981',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                margin: '0 auto 20px',
                fontSize: '24px',
                fontWeight: '800',
                color: '#10b981',
                fontFamily: 'monospace'
              }}>
                2
              </div>
              <h3 style={{ 
                margin: '0 0 12px 0',
                fontSize: '18px',
                fontWeight: '700',
                color: '#ffffff'
              }}>
                They Subscribe
              </h3>
              <p style={{ 
                fontSize: '14px',
                color: '#a0aec0',
                margin: 0,
                lineHeight: '1.6'
              }}>
                Your friend signs up using your referral link
              </p>
            </div>

            {/* Step 3 */}
            <div style={{ textAlign: 'center' }}>
              <div style={{
                width: '50px',
                height: '50px',
                borderRadius: '10px',
                backgroundColor: '#0f1419',
                border: '2px solid #f59e0b',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                margin: '0 auto 20px',
                fontSize: '24px',
                fontWeight: '800',
                color: '#f59e0b',
                fontFamily: 'monospace'
              }}>
                3
              </div>
              <h3 style={{ 
                margin: '0 0 12px 0',
                fontSize: '18px',
                fontWeight: '700',
                color: '#ffffff'
              }}>
                You Get Rewarded
              </h3>
              <p style={{ 
                fontSize: '14px',
                color: '#a0aec0',
                margin: 0,
                lineHeight: '1.6'
              }}>
                Earn 1 month free for every 3 successful referrals
              </p>
            </div>
          </div>
        </div>

        {/* Benefits */}
        <div style={{
          backgroundColor: '#1a1f2e',
          border: '1px solid #2d3748',
          borderRadius: '12px',
          padding: '40px',
          marginBottom: '40px'
        }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '30px' }}>
            <Users size={24} color="#00d9ff" />
            <h2 style={{ 
              margin: 0,
              fontSize: '24px',
              fontWeight: '700',
              color: '#ffffff'
            }}>
              Program Benefits
            </h2>
          </div>

          <div style={{ display: 'grid', gap: '15px' }}>
            {[
              'Unlimited referrals - no cap on how much you can earn',
              'Referrals never expire once qualified',
              'Track all your referrals in your dashboard',
              'Rewards applied automatically to your account'
            ].map((benefit, index) => (
              <div key={index} style={{ display: 'flex', alignItems: 'start', gap: '12px' }}>
                <div style={{
                  width: '24px',
                  height: '24px',
                  borderRadius: '50%',
                  backgroundColor: 'rgba(16, 185, 129, 0.2)',
                  border: '1px solid rgba(16, 185, 129, 0.4)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  flexShrink: 0,
                  marginTop: '2px'
                }}>
                  <Check size={14} color="#10b981" />
                </div>
                <p style={{ 
                  margin: 0,
                  fontSize: '15px',
                  color: '#a0aec0',
                  lineHeight: '1.6'
                }}>
                  {benefit}
                </p>
              </div>
            ))}
          </div>
        </div>

        {/* Coming Soon */}
        <div style={{
          backgroundColor: '#1a1f2e',
          border: '1px solid rgba(245, 158, 11, 0.3)',
          borderLeft: '4px solid #f59e0b',
          borderRadius: '12px',
          padding: '30px',
          textAlign: 'center'
        }}>
          <p style={{ 
            fontSize: '16px',
            color: '#a0aec0',
            margin: 0,
            lineHeight: '1.7'
          }}>
            Referral program launching soon. Stay tuned for your unique referral link and tracking dashboard!
          </p>
        </div>
      </div>
    </div>
  );
}

export default ReferFriend;